module.exports = __webpack_public_path__ + "static/media/8.5fef97c7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/8.JPG
// module id = 478
// module chunks = 0